import { DefaultState, TableDataResponse } from 'features/types';
import { Paging, SelectItem, Tab } from 'api/types';
import { JobSeekerOtherProfileLinks } from 'features/job-seeker-profile';

export interface JobSeekerJobSeekersFiltersData { }

export type JobSeekerJobSeekersTableFilters = {
  text?: string;
  tab: string;
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  assignedPrograms?: SelectItem[];
};

export type JobSeekerJobSeekersTableRequestFiltersData = {
  text?: string;
  tab: string;
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  assignedPrograms?: string[];
};

export type JobSeekerJobSeekersTableRequestData = {
  paging: Paging;
  filters: JobSeekerJobSeekersTableRequestFiltersData;
  onBehalfOfOrganizationId?: string;
};

export type JobSeekerJobSeekersState = DefaultState & {
  currentFilters: JobSeekerJobSeekersTableFilters;
  requestData: JobSeekerJobSeekersTableRequestData;
  data: {
    tableDataIsLoading: boolean;
    tabsIsLoading: boolean;
    tableData: TableDataResponse<JobSeekerJobSeekersTableView>;
    tabs: Tab[];
    filters: JobSeekerJobSeekersFiltersData | null;
  },

};

export type JobSeekerJobSeekersEnhancedFiltersForm = {
  location: google.maps.LatLngLiteral | null;
  fullAddress?: string;
  radius?: string | number;
  assignedPrograms?: SelectItem[];
}

export type GetJobSeekerJobSeekersTabsFilters = JobSeekerJobSeekersEnhancedFiltersForm & {
  text?: string;
};

export type JobSeekerProfileRestrictedView = {
  restricted: true;
  name: string;
  photo?: string;
};

export type JobSeekerJobSeekersTableView = {
  id: string;
  name: string;
  nickName?: string;
  profileHeadline?: string;
  photo?: string;
  phone?: string | null;
  email: string;
  city?: string;
  state?: string;
  zipcode?: number;
  employmentStatus: string[];
  skills?: string[];
  experienceLevels?: string[];
  isVerified: boolean;
  lastLoginAt?: Date;
  programs: string[];
  isCommunityAdmin: boolean;
  leadPrograms: string[];
  managingOnBehalfOf?: string;
  otherProfileLinks?: JobSeekerOtherProfileLinks;
  profileIsPrivate?: boolean;
  profileIsPublicEmploymentStatuse?: boolean;
  profileIsPublicZipCode?: boolean;
  profileIsPublicEmailAddress?: boolean;
  profileIsPublicPhone?: boolean;
  profileIsPublicOneClickResume?: boolean;
  signUpCompleted: boolean;
  managerUsersNames?: string;
  joiningSource?: string;
  joiningSourceLink: string;
  addedByUserName?: string;
  invitedByName?: string;
  professionalDescription?: string;
  resumeLink?: string;
};

export enum JobSeekerJobSeekersTabs {
  All = 'All',
  Verified = 'Verified',
  NotVerified = 'NotVerified',
}

export enum FilterTypes {
  Organization = 'Organization',
  JobSeeker = 'JobSeeker',
}
